import { useEffect, useState } from "react";
import { publicApi } from "../admin/api";

// Lightweight in-memory cache (per browser tab session)
let _cache = null;

/**
 * Public Home KPIs. Auto-counted from DB with optional manual overrides
 * configured in `Admin · Impostazioni → KPI Home`.
 *
 * Returns `null` while loading. Shape:
 *   { hotels, rooms, pipeline_hotels, pipeline_rooms, auto: {...} }
 */
export function useStats() {
  const [stats, setStats] = useState(_cache);

  useEffect(() => {
    if (_cache) {
      setStats(_cache);
      return;
    }
    publicApi
      .get("/stats")
      .then((r) => {
        _cache = r.data;
        setStats(r.data);
      })
      .catch(() => {});
  }, []);

  return stats;
}

export function invalidateStats() {
  _cache = null;
}
